import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76c83686"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-auto" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "table table-hover table-v2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  colspan: 6,
  class: "fw-bold small text-uppercase text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_BasePlaceholderTable = _resolveComponent("BasePlaceholderTable")!
  const _component_NotificationTemplateOverviewItem = _resolveComponent("NotificationTemplateOverviewItem")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_NotificationTemplateDetail = _resolveComponent("NotificationTemplateDetail")!
  const _component_BaseOffcanvas = _resolveComponent("BaseOffcanvas")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('notificationTemplates'),
          mb: 4,
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent
        }, null, 8, ["title", "onRefresh"]),
        _createVNode(_component_GenericFormWrapper, {
          submitData: _ctx.doNothing,
          pageUI: _ctx.pageUI,
          hideButtons: true
        }, {
          content: _withCtx(({errors}) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_input_select, {
                  modelValue: _ctx.module,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.module) = $event)),
                  label: _ctx.$t('module'),
                  name: "module",
                  options: _ctx.allModules,
                  errors: errors,
                  onChange: _ctx.reloadContent
                }, null, 8, ["modelValue", "label", "options", "errors", "onChange"])
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("table", _hoisted_4, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('type')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('communicationType')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('language')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('subType')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('subject')), 1),
                    _hoisted_5
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_ctx.pageUI.isNotReady())
                    ? (_openBlock(), _createBlock(_component_BasePlaceholderTable, {
                        key: 0,
                        "n-cols": 6
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.pageUI.isReady())
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (!_ctx.templates?.results?.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                              _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.$t('noResults')), 1)
                            ]))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.templates.results, (template) => {
                              return (_openBlock(), _createBlock(_component_NotificationTemplateOverviewItem, {
                                moduleCode: _ctx.module,
                                parentPageUI: _ctx.pageUI,
                                template: template,
                                key: template.id,
                                onDelete: _ctx.deleteTemplate,
                                onUpdate: _ctx.openDetail
                              }, null, 8, ["moduleCode", "parentPageUI", "template", "onDelete", "onUpdate"]))
                            }), 128))
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["submitData", "pageUI"])
      ]),
      _: 1
    }),
    _createVNode(_component_BaseOffcanvas, {
      id: "notificationTemplateUpdateOffCanvas",
      title: _ctx.$t('notificationTemplate'),
      label: _ctx.$t('notificationTemplate'),
      class: "offcanvas-wide"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_NotificationTemplateDetail, {
          moduleCode: _ctx.module,
          key: _ctx.templateSequence,
          notificationTemplate: _ctx.selectedTemplate,
          onUpdate: _ctx.reloadContentAndUpdateSelectedTemplate
        }, null, 8, ["moduleCode", "notificationTemplate", "onUpdate"]))
      ]),
      _: 1
    }, 8, ["title", "label"])
  ], 64))
}